import type { FC } from 'types/react';

import { showCookieConsentEvent, $cookieConsent } from 'stores/cookieConsent/model';
import { CookieBanner } from 'components/modals/CookiesModal/CookieBanner';
import { AppLayout } from 'components/layouts/AppLayout';
import { Preloader } from 'ui-kit/components/Preloader';
import { $currentLanguageCode } from 'stores/language';
import { COOKIE_CONSENT_NAME } from 'constants/cookie';
import { Dashboard } from 'pages/Dashboard/Dashboard';
import { PrivateRoute } from 'routes/PrivateRoute';
import { DASHBOARD_LINK } from 'constants/routes';
import { $isLoading } from 'stores/loading/model';
import { Routes, Route } from 'react-router-dom';
import { Modal } from 'components/modals/Modal';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import Cookies from 'js-cookie';
import 'stores/init';

import { DASHBOARD_ROUTES, ROUTES } from './constants';

export const App: FC = () => {
    const [currentLanguageCode, isLoading, showCookieConsentBanner] = useUnit([
        $currentLanguageCode,
        $isLoading,
        $cookieConsent
    ]);
    const { i18n: translator } = useTranslation();

    // const [message, setMessage] = useState('');
    // const [onlineUsers, setOnlineUsers] = useState(0);
    // const [roomName, setRoomName] = useState('');
    // const [clients, setClients] = useState([]);

    useEffect(() => {
        if (!Cookies.get(COOKIE_CONSENT_NAME)) {
            showCookieConsentEvent(true);
        }
    }, []);

    useEffect(() => {
        translator.changeLanguage(currentLanguageCode || 'du');
    }, [currentLanguageCode, translator]);

    return (
        <>
            <Preloader isLoading={isLoading} />
            <AppLayout>
                <Modal />
                <Routes>
                    {ROUTES.map(({ element, path }, index) => (
                        <Route element={element} key={index} path={path} />
                    ))}
                    <Route
                        element={
                            <PrivateRoute>
                                <Dashboard />
                            </PrivateRoute>
                        }
                        path={DASHBOARD_LINK}
                    >
                        {DASHBOARD_ROUTES.map(({ element, path }, index) => (
                            <Route element={element} key={index} path={path} />
                        ))}
                    </Route>
                </Routes>
                {showCookieConsentBanner && <CookieBanner />}
            </AppLayout>
        </>
    );
};
